// ─── AR Reconciliation – Access & Hospital helpers ─────────────────────────────
// Centralised so both the Header tab and the page route-guard stay in sync.

// Roles that grant access to AR Reconciliation.
export const AR_ACCESS_ROLE = 'ar_dash';
export const AR_VIEW_ROLE = 'ar_dash_view';
export const AR_ROLES = [AR_ACCESS_ROLE, AR_VIEW_ROLE];

// Mobile-based role mapping for AR Reconciliation
export const AR_ROLE_BASED_MOBILES = {
  '8600062361': 'ar_dash',
  '9986943464': 'ar_dash',
  '9921782780': 'ar_dash',
  '9819297360': 'ar_dash',
  '9022841188': 'ar_dash',
  '6302278076': 'ar_dash',
  '9015112729': 'ar_dash',
  '8882907911': 'ar_dash',
  '9582157997': 'ar_dash',
  '9667069572': 'ar_dash',
  '9811130032': 'ar_dash',
  '9121661476': 'ar_dash',
  '9384471032': 'ar_dash',
  '8248301322': 'ar_dash',
  '8220142004': 'ar_dash',
  '9952083734': 'ar_dash',
  '9844303498': 'ar_dash',
  '7893050403': 'ar_dash',
  '9296511421': 'ar_dash',
  '8210499935': 'ar_dash',
  '8114388610': 'ar_dash',
  '9090963722': 'ar_dash',
  '9807424395': 'ar_dash',
  '7389285956': 'ar_dash',
  '8699116698': 'ar_dash',
  '8271045374': 'ar_dash',
  '8090099330': 'ar_dash',
  '9431274600': 'ar_dash',
  '8121688779': 'ar_dash',
  '7047591224': 'ar_dash',
  '7007929299': 'ar_dash_view',
  '8104937369': 'ar_dash_view',
  '9289392643': 'ar_dash_view',
  '9990368989': 'ar_dash_view',
  '9999067465': 'ar_dash_view',
  '9384703493': 'ar_dash_view',
  '6385452420': 'ar_dash_view',
  '9606562041': 'ar_dash_view',
  '8249859881': 'ar_dash_view',
  '9580330344': 'ar_dash_view',
  '7737950522': 'ar_dash_view',
  '8011825755': 'ar_dash_view',
  '9341799179': 'ar_dash_view',
  '8297841823': 'ar_dash_view',
};

// Hardcoded hospitals list for specific users
export const HARDCODED_HOSPITALS = [
  { name: "Deccan Multispeciality Hardikar Hospital", id: "z1ozrReFzb" },
  { name: "Poona Eye Care Hospital", id: "8MZhkZlF95" },
  { name: "Aaradhya Netralaya", id: "PPFKGoYYnd" },
  { name: "Lokmanya Hospital - Chinchwad", id: "n3AQsS3WEn" },
  { name: "Balajee Hospital Malad East", id: "DghqBVzweE" },
  { name: "Laxmijyot Hospital", id: "jDNHDzFfpE" },
  { name: "Dalvi Nursing Home - Dr Archana Anilkumar Bhosale", id: "V9Qoo6oIQZ" },
  { name: "SBS Hospital - Andheri", id: "7xlxtp6zFH" },
  { name: "Kimaya Gynec and Fertility Centre", id: "Nv5CAnnU35" },
  { name: "Geethasree Hospitals - Coimbatore", id: "zMVcC10cTV" },
  { name: "Vision Xperts Eye Hospital", id: "tKWZjZEbU6" },
  { name: "Eyal Hospital", id: "r5ov9NzHyt" },
  { name: "Gleneagles Hospitals - Richmond Road", id: "rCroggFtOU" },
  { name: "Life Plus", id: "gdsGwECt3T" },
  { name: "Synergy Global Care Hospital", id: "VdM6OVOLmU" },
  { name: "Freya Hospital - Ranchi", id: "YCKgSChkaO" },
  { name: "Neelachal Hospital", id: "G2M7fkVimO" },
  { name: "Ridansh Hospital", id: "F2pcLZYBoL" },
  { name: "Dr. OP Chaudhary Hospital", id: "mUmBRQlKqS" },
  { name: "Panacea Hospital", id: "QWMhJTZ1Em" },
  { name: "Medicover Hospital - Secunderabad", id: "uRqJv7KATH" },
  { name: "Medicover Navi Mumbai", id: "BQQX5Xsik7" },
  { name: "Medicover MVP", id: "EaBPM9Twsj" },
  { name: "Eye Mantra Hospital", id: "GDunfdR4GA" },
  { name: "Aadhya9 Multi-Speciality Hospital", id: "XqxtbB52QQ" },
  { name: "Amerix Hospital", id: "sArtFUVwY8" },
  { name: "SMC Hospital - Raipur", id: "fgD50CCK3N" },
  { name: "Capital Hospital - Vijayawada", id: "ZNh66PHWII" },
  { name: "Kare Partner Hospital - Chandigarh", id: "RCo2M2alh4" },
  { name: "KARE Partner - Punchkula", id: "oUnE0gnxXe" },
  { name: "Usthi Hospital", id: "etpeDhvPTq" },
  { name: "Holy Promise", id: "IQARXhFVYv" }
];

export const HARDCODED_HOSPITAL_MAP = HARDCODED_HOSPITALS.reduce((acc, curr) => {
  acc[curr.id] = curr.name;
  return acc;
}, {});

const HARDCODED_HOSPITAL_IDS_LIST = HARDCODED_HOSPITALS.map((h) => h.id);

// TEMP: users (matched by email OR username) that should always get AR access +
// hardcoded hospitals until their real roles / HospitalIds are provisioned.
// Remove once the backend is ready.
const TEMP_WHITELIST_EMAILS = [
  'sunny.sen@pristyncare.com',
  'rohit.kumar6@pristyncare.com',
  'md.arif@pristyncare.com',
];

const TEMP_WHITELIST_USERNAMES = [
  'sunny.sen',
  'rohit.kumar6',
  'md.arif',
];

const TEMP_FALLBACK_HOSPITAL_IDS = ['GDunfdR4GA', 'X8nBAtLR3H', 'Nv5CAnnU35'];

const USER_HARDCODED_HOSPITALS = {
  'sunny.sen@pristyncare.com': ['GDunfdR4GA', 'X8nBAtLR3H', 'Nv5CAnnU35'],
  'sunny.sen': ['GDunfdR4GA', 'X8nBAtLR3H', 'Nv5CAnnU35'],
  'rohit.kumar6@pristyncare.com': HARDCODED_HOSPITAL_IDS_LIST,
  'rohit.kumar6': HARDCODED_HOSPITAL_IDS_LIST,
  'md.arif@pristyncare.com': HARDCODED_HOSPITAL_IDS_LIST,
  'md.arif': HARDCODED_HOSPITAL_IDS_LIST,
};

const normalize = (v) => (v == null ? '' : String(v).trim().toLowerCase());

const getUserEmail = (user) =>
  normalize(user?.email || user?.emailId || user?.Email || user?.email_id);

const getUserName = (user) =>
  normalize(user?.username || user?.user_name || user?.userName || user?.name || user?.userId);

const isWhitelisted = (user) =>
  TEMP_WHITELIST_EMAILS.includes(getUserEmail(user)) ||
  TEMP_WHITELIST_USERNAMES.includes(getUserName(user));

const getMobileRole = (user) => {
  const raw = String(user?.otpMobile || (typeof localStorage !== 'undefined' ? localStorage.getItem('userMobile') : '') || '').trim();
  const mobile = raw.slice(-10);
  return AR_ROLE_BASED_MOBILES[mobile] || AR_ROLE_BASED_MOBILES[raw] || null;
};

/**
 * True when the user may access AR Reconciliation.
 * Checks mobile mapping first, then whitelist (email/username), then user.roles.
 */
export function hasArAccess(user) {
  if (!user) return false;

  // 1. Mobile-based role check (user.otpMobile or localStorage userMobile)
  if (getMobileRole(user)) return true;

  // 2. TEMP whitelist bypass (by email / username)
  if (isWhitelisted(user)) return true;

  // 3. User roles check
  const validRoles = AR_ROLES.map((r) => r.toLowerCase());
  const role = normalize(user?.roles?.role);
  if (validRoles.includes(role)) return true;

  const otherRoles = user?.roles?.otherRoles;
  if (Array.isArray(otherRoles)) {
    return otherRoles.some((r) => validRoles.includes(normalize(r)));
  }
  return false;
}

/**
 * True when the user only has view permission (`ar_dash_view`) and does NOT have full action permissions (`ar_dash`).
 */
export function isArViewOnly(user) {
  if (!user) return false;
  if (isWhitelisted(user)) return false;

  // 1. Mobile-based role check
  const mobileRole = getMobileRole(user);
  if (mobileRole) {
    return mobileRole.toLowerCase() === AR_VIEW_ROLE.toLowerCase();
  }

  // 2. User roles check
  const role = normalize(user?.roles?.role);
  const otherRoles = Array.isArray(user?.roles?.otherRoles)
    ? user.roles.otherRoles.map(normalize)
    : [];
  const allRoles = [role, ...otherRoles];

  const hasFullAccess = allRoles.includes(AR_ACCESS_ROLE.toLowerCase());
  const hasViewAccess = allRoles.includes(AR_VIEW_ROLE.toLowerCase());

  return hasViewAccess && !hasFullAccess;
}

/**
 * True when the user can perform write/dispute/sign-off actions (i.e. has ar_dash full access).
 */
export function canPerformArAction(user) {
  return hasArAccess(user) && !isArViewOnly(user);
}

/**
 * Returns the user's hospital ids as a clean array of strings.
 * `HospitalIds` may be a single string or an array. Falls back to the TEMP
 * hardcoded id for whitelisted users when nothing is assigned.
 */
export function getUserHospitalIds(user) {
  const email = getUserEmail(user);
  const username = getUserName(user);

  // If user has specific hardcoded hospital mapping
  if (USER_HARDCODED_HOSPITALS[email]) {
    return [...USER_HARDCODED_HOSPITALS[email]];
  }
  if (USER_HARDCODED_HOSPITALS[username]) {
    return [...USER_HARDCODED_HOSPITALS[username]];
  }

  const raw = user?.HospitalIds;
  let ids = [];

  if (Array.isArray(raw)) {
    ids = raw;
  } else if (raw != null && String(raw).trim() !== '') {
    ids = [raw];
  }

  ids = ids.map((id) => String(id).trim()).filter(Boolean);

  // TEMP: give whitelisted users (by email) a working hospital id if none assigned
  if (ids.length === 0 && isWhitelisted(user)) {
    return [...TEMP_FALLBACK_HOSPITAL_IDS];
  }

  return ids;
}
